export default {
  name: 'custom_email_field',
  component_path: 'modules/procedures/blocks/BlockInputEmail',
  static_mandatory: ['email']
}